// Authenticate through fetch: browser navigation omits the Origin header that
// the API uses to select the Backoffice session cookie.
export async function downloadArchiveFile(url: string, filename: string) {
  const endpoint = new URL(url, window.location.origin);
  endpoint.searchParams.set('delivery', 'link');
  const response = await fetch(endpoint, {
    credentials: 'include',
    cache: 'no-store',
    redirect: 'error',
    signal: AbortSignal.timeout(45000),
  }).catch(() => {
    throw new Error(
      'Unable to prepare the download. Check your connection and try again.'
    );
  });
  if (!response.ok) {
    throw new Error(
      response.status === 401
        ? 'Your session has expired. Please sign in again before downloading.'
        : response.status === 403
        ? 'You do not have permission to download this archive file.'
        : response.status === 404
        ? 'This file is unavailable in the selected archive import.'
        : 'Unable to download the archive file. Please try again.'
    );
  }
  if (response.headers.get('Content-Type')?.includes('application/json')) {
    const body: unknown = await response.json();
    if (
      !body ||
      typeof body !== 'object' ||
      !('url' in body) ||
      typeof body.url !== 'string' ||
      new URL(body.url).protocol !== 'https:'
    ) {
      throw new Error('The archive returned an invalid download link.');
    }
    window.location.assign(body.url);
  } else {
    // Local archive storage streams bytes from the authenticated API request.
    const objectUrl = URL.createObjectURL(await response.blob());
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = filename;
    anchor.click();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
  }
}
